import { render, staticRenderFns } from "./DashboardCorporate.vue?vue&type=template&id=67808d26&"
import script from "./DashboardCorporate.vue?vue&type=script&lang=js&"
export * from "./DashboardCorporate.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCorporate.vue?vue&type=style&index=0&id=67808d26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports